/* product.js — hide non-selected variants */

(function () {
  // ---------- small utilities ----------
  function jqReady(fn) {
    function run() {
      if (document.readyState !== 'loading') fn();
      else document.addEventListener('DOMContentLoaded', fn);
    }
    if (window.jQuery) run();
    else {
      var tries = 0, iv = setInterval(function () {
        if (window.jQuery) { clearInterval(iv); run(); }
        else if (++tries > 200) { clearInterval(iv); }
      }, 30);
    }
    // if your header emits a custom ready
    window.addEventListener('w3-DOMContentLoaded', function(){ if (window.jQuery) fn(); }, { once: true });
  }

  function eager($img) {
    if (!$img || !$img.length) return;
    var ds = $img.attr('data-src');
    if (ds && !$img.attr('src')) { $img.attr('src', ds).removeAttr('data-src'); }
    $img.attr('decoding', 'async');
  }

  function norm(u){ if(!u) return ''; try { return u.split('?')[0].toLowerCase(); } catch(e){ return (u+'').toLowerCase(); } }

  jqReady(function () {
    var $ = window.jQuery;
    if (!$) return;

    // ---------- initialize BOTH carousels once ----------
    var $carousels = $('.desktop .carousel, .mobile .carousel');

    $carousels.each(function () {
      var $c = $(this);
      if ($c.data('flickity')) return;
      var isDesktop = !!$c.closest('.desktop').length;
      $c.flickity({
        wrapAround: true,
        pageDots: false,
        cellAlign: isDesktop ? 'right' : 'center',
        prevNextButtons: true
      });
    });

    // ---------- map variantId -> { featuredId, imageUrl } from #select_variant ----------
    function buildVariantMap() {
      var map = {};
      $('#select_variant option').each(function () {
        var $o = $(this);
        var vid = ($o.val() || '').trim(); // string id
        if (!vid) return;
        map[vid] = {
          featuredId: ($o.attr('data-featured-media-id') || '').trim(), // Shopify media.id (string)
          image: norm($o.attr('data-image') || '')
        };
      });
      return map;
    }

    // NEW: build a Set of all featured media ids across variants (to infer variant-specific slides)
    function buildVariantMediaSet(map) {
      var s = new Set();
      for (var k in map) {
        if (map.hasOwnProperty(k)) {
          var id = (map[k].featuredId || '').trim();
          if (id) s.add(id);
        }
      }
      return s;
    }

    var variantMap = buildVariantMap();
    var variantMediaSet = buildVariantMediaSet(variantMap);

    // ---------- read current variant id ----------
    function getCurrentVariantId() {
      var hid = document.querySelector('form[action*="/cart/add"] input[name="id"]');
      if (hid && hid.value) return String(hid.value).trim();
      var $sel = $('#select_variant');
      if ($sel.length) return String($sel.val() || '').trim();
      return '';
    }

    // ---------- filter one carousel: ONLY selected variant + all global ----------
    function filterOneCarousel($carousel, featuredId, wantUrl) {
      var $cells = $carousel.find('.carousel-cell');
      if (!$cells.length) return;

      var targetEl = null;
      var firstVisibleEl = null;
      var visibleCount = 0;

      $cells.each(function (_, el) {
        var $el = $(el);

        // Infer variant-specific vs global:
        // - Explicit data-attached="true"  => variant-specific
        // - Explicit data-attached="false" => global
        // - Missing data-attached          => variant-specific if its media-id is in any variant’s featured ids; else global
        var att = ($el.attr('data-attached') || '').toLowerCase();
        var mid = ($el.attr('data-media-id') || '').trim(); // media.id (string)

        var isExplicitTrue  = (att === 'true');
        var isExplicitFalse = (att === 'false');
        var inferredVariantSpecific = (!isExplicitTrue && !isExplicitFalse) && (mid && variantMediaSet.has(mid));

        var isVariantSpecific = isExplicitTrue || inferredVariantSpecific;
        var isGlobal          = isExplicitFalse || (!isExplicitTrue && !isExplicitFalse && !inferredVariantSpecific);

        var $img = $el.find('img');
        var src  = norm($img.attr('src') || '');
        var dsrc = norm($img.attr('data-src') || '');
        var set  = ($img.attr('srcset') || '').toLowerCase();

        // exact featured match (ID first), then URL fallback
        var matchesFeatured = (featuredId && mid === featuredId) ||
                              (wantUrl && (src.indexOf(wantUrl) !== -1 || dsrc.indexOf(wantUrl) !== -1 || set.indexOf(wantUrl) !== -1));

        // SHOW RULE (strict):
        // - GLOBAL => always show
        // - VARIANT-SPECIFIC => show only the featured; hide the rest
        var show = isGlobal || (isVariantSpecific && matchesFeatured);

        if (show) {
          $el.show();
          eager($img);
          visibleCount++;
          if (!firstVisibleEl) firstVisibleEl = el;
          if (matchesFeatured) targetEl = el;
        } else {
          $el.hide();
        }
      });

      // Safety: if nothing visible (shouldn't happen), show featured or first cell
      if (visibleCount === 0) {
        var picked = null;
        $cells.each(function(_, el){
          if (!picked) {
            var mid = ($(el).attr('data-media-id') || '').trim();
            if (featuredId && mid === featuredId) picked = el;
          }
        });
        if (!picked) picked = $cells.get(0);
        $cells.hide();
        $(picked).show().find('img').each(function(){ eager($(this)); });
        targetEl = picked; firstVisibleEl = picked; visibleCount = 1;
      }

      // Refresh Flickity & select the exact element
      $carousel.flickity('reloadCells');
      $carousel.flickity('resize');

      if (targetEl) {
        $carousel.flickity('selectCell', targetEl);
      } else if (firstVisibleEl) {
        $carousel.flickity('selectCell', firstVisibleEl);
      }
    }

    // ---------- update all carousels from current variant ----------
    function updateGallery(reason) {
      // Keep maps fresh in case theme swaps options dynamically
      variantMap = buildVariantMap();
      variantMediaSet = buildVariantMediaSet(variantMap);

      var vid = getCurrentVariantId();
      var meta = variantMap[vid] || { featuredId: '', image: '' };
      var featuredId = (meta.featuredId || '').trim();
      var wantUrl    = meta.image;

      // Debug
      console.log('[gallery:update]', { reason: reason, variantId: vid, featuredId: featuredId });

      $carousels.each(function () {
        filterOneCarousel($(this), featuredId, wantUrl);
      });
    }

    // ---------- listeners (product.js only) ----------
    $(document).on('change', '#select_variant', function(){ updateGallery('select:change'); });

    (function watchHiddenId(){
      var hid = document.querySelector('form[action*="/cart/add"] input[name="id"]');
      if (!hid) return;
      function sync(reason){ updateGallery(reason); }

      // property hook (catches jQuery .val())
      try {
        var proto = Object.getPrototypeOf(hid) || HTMLInputElement.prototype;
        var desc  = Object.getOwnPropertyDescriptor(proto, 'value');
        if (desc && desc.configurable) {
          Object.defineProperty(hid, 'value', {
            get: function(){ return desc.get.call(this); },
            set: function(v){ desc.set.call(this, v); sync('hidden:prop-set'); }
          });
        }
      } catch(e) {}

      hid.addEventListener('input',  function(){ sync('hidden:input');  });
      hid.addEventListener('change', function(){ sync('hidden:change'); });
      var mo = new MutationObserver(function(){ sync('hidden:mutation'); });
      mo.observe(hid, { attributes: true, attributeFilter: ['value'] });
      var last = hid.value;
      setInterval(function(){ if (hid.value !== last){ last = hid.value; sync('hidden:poll'); } }, 200);
    })();

    ['variant:change','variant:changed','product:variant-change'].forEach(function(evt){
      document.addEventListener(evt, function(){ updateGallery('event:'+evt); }, true);
    });

    $(document).on('change', 'input[name="Flavor"], input[name="Bundle & Save"]', function(){
      setTimeout(function(){ updateGallery('radios'); }, 0);
    });

    // ---------- initial paint ----------
    updateGallery('init');

    // ---------- keep Flickity from landing on hidden cells (direction-aware, minimal change) ----------
    $carousels.off('select.flickity.hpFix').on('select.flickity.hpFix', function () {
      var $carousel = $(this);
      var flkty = $carousel.data('flickity');
      if (!flkty || !flkty.cells || flkty.selectedIndex == null) return;
      if ($carousel.data('hp-skip')) return; // guard re-entry

      var idx = flkty.selectedIndex;
      var $sel = $(flkty.cells[idx].element);

      // If we landed on a visible cell, remember it and do nothing
      if ($sel.css('display') !== 'none') {
        $carousel.data('hp-last-index', idx);
        return;
      }

      // Infer the user's direction from the last visible index
      var last = $carousel.data('hp-last-index');
      var len  = flkty.cells.length;
      if (typeof last !== 'number') last = idx;

      var fwd  = (idx - last + len) % len;   // forward distance
      var back = (last - idx + len) % len;   // backward distance
      var step = (back <= fwd) ? -1 : +1;    // follow user's likely intent

      // Walk in that direction until we hit a visible slide (or give up after len steps)
      var i = idx, tries = 0;
      while (tries++ < len) {
        i = (i + step + len) % len;
        var $cell = $(flkty.cells[i].element);
        if ($cell.css('display') !== 'none') {
          $carousel.data('hp-skip', true);
          $carousel.flickity('select', i, true, false); // slide transition
          $carousel.data('hp-skip', false);
          $carousel.data('hp-last-index', i);
          break;
        }
      }
    });

    // ==================== YOTPO (unchanged) ====================
    let nIntervId;
    function waitingYotpoLoadPDP() { if (!nIntervId) nIntervId = setInterval(yotpoReviewsWidgetLoadedPDP, 100); }
    function yotpoReviewsWidgetLoadedPDP() {
      var y1 = $('.yotpo-widget-instance .yotpo-sr-bottom-line-text');
      var y2 = $('.yotpo-widget-instance .yotpo-bottom-line-basic-text');
      if (y1.length) formatReviewsCountNumber(y1[0], false);
      if (y2.length) formatReviewsCountNumber(y2[0], true);
    }
    function formatReviewsCountNumber(widget, isClear) {
      if (!widget) return;
      var html = $(widget).html() || '';
      if (html && (html.includes('reviews') || html.includes('Reviews'))) {
        var m = html.match(/(\d+)/);
        if (m) {
          var reviewsCount = m[1];
          if (+reviewsCount > 999) {
            var arr = ('' + reviewsCount).split('');
            arr.splice(arr.length - 3, 0, ',');
            $(widget).html(html.replace(reviewsCount, arr.join('')));
          }
          if (isClear) { clearInterval(nIntervId); nIntervId = null; }
        }
      }
    }
    if ($('.yotpo-widget-instance').length) waitingYotpoLoadPDP();
    // ==================== /YOTPO ====================
  });
})();
